export default __webpack_public_path__ + "waves-cta-card-mobile.svg";